var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g({attrs:{"type":"email","id":_vm.id,"name":_vm.name,"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"autocomplete":_vm.autocomplete,"autofocus":_vm.autofocus,"min":_vm.minLength,"max":_vm.maxLength,"required":_vm.required,"state":_vm.state,"size":_vm.size}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }